module.exports = __webpack_public_path__ + "img/shixi04.374401bd.png";